import http from "@/utils/http";


export const MessagePushAdminApi = {

    getMessagePushAdminListByCurrentCompany() {
        return http.get(`/server/messagePushAdmin/getMessagePushAdminListByCurrentCompany`)
    },
    addMessagePushAdmin(data) {
        return http.post(`/server/messagePushAdmin/addMessagePushAdmin`,data)
    },
    deleteMessagePushAdmin(userId) {
        return http.get(`/server/messagePushAdmin/deleteMessagePushAdmin/${userId}`)
    },
}